import React, { useState } from 'react'
import { StyleSheet, TouchableWithoutFeedback, View } from 'react-native'
import { Surface, Text } from 'react-native-paper'

import CheckCard from 'components/CheckCard'
import { clampQuantity } from 'src/recipes'

const Ingredient = (props) => {
  const [checked, setChecked] = useState(false)

  return (
    <CheckCard
      {...{ ...props, checked, onPress: () => setChecked(!checked) }}
    />
  )
}

const Ingredients = ({
  visible,
  ingredients,
  numberOfServings,
  baseServings,
}) => {
  if (!visible) return null

  return (
    <View style={styles.ingredientsContainer}>
      {ingredients.map((item, index) => (
        <Ingredient
          {...{
            key: index,
            title: item.name,
            subtitle:
              clampQuantity((item.quantity / baseServings) * numberOfServings) +
              ' ' +
              item.unit,
          }}
        />
      ))}
    </View>
  )
}

const IngredientAccordion = (props) => {
  const [visible, setVisible] = useState(true)
  return (
    <Surface style={styles.container} elevation={0}>
      <TouchableWithoutFeedback onPress={() => setVisible(!visible)}>
        <View style={styles.headerContainer}>
          <Text style={{ fontWeight: 'bold', fontSize: 18 }}>
            Ingredients you'll need
          </Text>
        </View>
      </TouchableWithoutFeedback>
      <Ingredients {...{ ...props, visible }} />
    </Surface>
  )
}
const styles = StyleSheet.create({
  container: {
    backgroundColor: 'transparent',
    borderColor: '#686a70',
    borderBottomWidth: 0,
    paddingBottom: 65,
    marginBottom: -45,
  },
  headerContainer: {
    paddingVertical: 20,
    paddingHorizontal: 12,
  },
  ingredientsContainer: {
    padding: 4,
  },
})

export default IngredientAccordion
